import { useEffect, useState } from "react";
import { Button, Input } from "@oc-labs/wt-storybook";
import ModalV2 from "../../../../components/ModalV2";
import useModal from "../../../../hooks/useModal";
import useAPI from "../../../../hooks/useAPI";
import toast from "react-hot-toast";

export default function AddUserModal({ companyId, onUserAdded }) {
  const { isOpen, close } = useModal("add-user");
  const api = useAPI();
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setEmail("");
    }
  }, [isOpen]);

  const handleAddUser = async () => {
    if (!email.trim()) {
      toast.error("Please enter an email");
      return;
    }
    try {
      await api.adminCompanyAddUser(companyId, email);
      toast.success(`User ${email} added successfully.`);
      onUserAdded();
      close();
    } catch (error) {
      console.error("Error adding user:", error);
      toast.error(error.response?.data?.message || "Failed to add user.");
    }
  };

  return (
    <ModalV2 name="add-user" title="Add User" className="w-[500px]">
      <div className="mt-4">
        <Input
          label="User Email"
          type="email"
          placeholder="Enter user email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mb-4"
        />
        <Button
          onClick={handleAddUser}
        >
          Add User
        </Button>
      </div>
    </ModalV2>
  );
}
